<template>
  <v-data-table
    :items="jobs"
    :headers="headers"
    :loading="isLoading"
    :items-per-page="500"
    :footer-props="{ itemsPerPageOptions : [500] }"
    must-sort
    sort-by="deliveryTime"
    hide-default-footer
    no-data-text="No Jobs Available"
  >
    <template v-slot:item="props">
      <tr
        class="cursor-pointer"
        @click="props.expand(!props.isExpanded)"
      >
        <td class="py-2 d-flex align-center">
          <v-icon
            color="primary"
            class="mx-1 cursor-pointer"
            v-text="
              props.isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'"
          />

          <div class="py-2">
            {{
              props.item.purchaseOrder &&
                props.item.purchaseOrder.store &&
                props.item.purchaseOrder.store.formatted_address ||
                'N/A'
            }}
          </div>
        </td>

        <td class="md">
          {{
            props.item.choosenTimeWindow &&
              convertSecondToFormattedTime(props.item.deliveryTime) ||
              'N/A'
          }}
        </td>

        <td>{{ props.item.numberOfPalletsDelivered || 'N/A' }}</td>
      </tr>
    </template>

    <template v-slot:expanded-item="props">
      <tr
        class="grey lighten-4"
      >
        <td
          class="pt-2 px-5 pb-5"
          :colspan="headers.length + 1"
        >
          <div class="primary--text subtitle-1 mb-2">
            Pallets
          </div>

          <v-card outlined>
            <v-data-table
              single-expand
              item-key="id"
              hide-default-footer
              :headers="palletHeaders"
              :items="props.item.pallets"
            >
              <template v-slot:item="palletProp">
                <tr
                  class="cursor-pointer"
                  @click="palletProp.expand(!palletProp.isExpanded)"
                >
                  <td>
                    <v-icon
                      color="primary"
                      class="mx-1"
                      v-text="
                        palletProp.isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'"
                    />

                    {{ palletProp.item.aggregateWeight.value }}
                    {{ palletProp.item.aggregateWeight.units }}
                  </td>
                  <td>
                    £ {{ palletProp.item.palletPrice }}
                  </td>
                  <td>
                    {{ getTotalProducts(palletProp.item) || 0 }}
                  </td>
                </tr>
              </template>

              <template v-slot:expanded-item="palletProp">
                <tr class="grey lighten-4">
                  <td
                    class="pa-5 pt-2"
                    :colspan="palletHeaders.length + 1"
                  >
                    <div class="primary--text subtitle-1 mb-2">
                      Products
                    </div>

                    <v-card outlined>
                      <v-data-table
                        hide-default-footer
                        :headers="productHeaders"
                        :items="palletProp.item.products || []"
                      />
                    </v-card>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import { parseJob } from '@/utils/documentParser';
import { jobsCollection, secureAuthSupplier, routesCollection } from '@/firebase';

export default {
  props: {
    routeDetails: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      jobs: [],
      headers: [
        { text: 'Delivery Location', sortable: false },
        { text: 'Delivery Time', value: 'deliveryTime' },
        { text: 'Delivered Pallets', sortable: false },
      ],
      palletHeaders: [
        { text: 'Agg. Pallet Weight', value: 'aggregateWeight' },
        { text: 'Pallet Price', value: 'palletPrice' },
        {
          text: 'Total no. of Products', sortable: false,
        },
      ],
      productHeaders: [
        { text: 'Description', value: 'description', sortable: false },
        { text: 'Units on Pallet', value: 'unitsOnPallet', sortable: false },
        { text: 'Is Topper', value: 'isTopper', sortable: false },
        { text: 'Quantity', value: 'quantity', sortable: false },
      ],
      unSubscribeJobs: () => {},
    };
  },
  mounted() {
    this.fetchJobs();
  },
  beforeDestroy() {
    this.unSubscribeJobs();
  },
  methods: {
    fetchJobs() {
      this.isLoading = true;

      this.unSubscribeJobs();
      this.unSubscribeJobs = secureAuthSupplier(jobsCollection)
        .where(
          'route',
          '==',
          routesCollection.doc(this.routeDetails.id),
        )
        .onSnapshot((snapshot) => {
          this.jobs = snapshot.docs.map(parseJob);

          this.isLoading = false;
        },
        () => {
          this.isLoading = false;
        });
    },
    getAggregatePalletWeight(product) {
      const productQuantity = product && product.unitsOnPallet;

      const palletWeight = product && product.pallet && product.pallet.emptyWeight;

      const productWeight = product && product.weight;

      if (!palletWeight && !productWeight) {
        return '';
      }

      if (!palletWeight && productWeight) {
        return `${productWeight.value} ${productWeight.units}`;
      }

      if (palletWeight && !productWeight) {
        return `${palletWeight.value} ${palletWeight.units}`;
      }

      const totalWeight = palletWeight.value + productWeight.value * productQuantity;
      return `${totalWeight} ${productWeight.units}`;
    },
    convertSecondToFormattedTime(secs) {
      if (!secs) {
        return 'N/A';
      }

      const padNumber = (number) => String(number).padStart(2, '0');

      const secNum = parseInt(secs, 10);
      const hours = padNumber(Math.floor(secNum / 3600));
      const minutes = padNumber(Math.floor(secNum / 60) % 60);

      return `${hours}:${minutes}`;
    },
    getTotalProducts(pallet) {
      return pallet.products
      && pallet.products.length
      && pallet.products.reduce((sum, product) => sum + product.quantity, 0);
    },
  },
};
</script>

<style scoped>
  .cursor-pointer {
    cursor: pointer !important;
  }
  td.md {
    width: 100px !important;
  }
</style>
